/**
 * Catalog copy — `/bikes` and `/bikes/:handle`.
 *
 * These pages have no Claude Design comp, so unlike the homepage there is no
 * verbatim source to port; the strings below come from the voice guide's list
 * of ten, which is the closest thing to an approved set. See `shop.ts` for what
 * may and may not change.
 *
 * One rule is doing real work here and should survive a copy pass:
 *
 *  - **Catalog copy does not claim a slot.** `/book` owns the live scheduler;
 *    these tiles may lead there, but cannot say a time is held or confirmed.
 */
export const bikes = {
  heroLine1: "Compare the cargo bikes",
  heroLine2: "in our Boulder shop",
  heroIntro:
    "Filter by brand, open any bike for photos and model details, then ask about availability or schedule a free 30-minute test ride with the passengers and cargo the bike needs to handle.",

  pastModelsHeading: "Past models",
  pastModelsBlurb:
    "These bikes have been out of stock for at least 90 days. Ask us about current alternatives.",

  emptyState: "No bikes are listed right now. Call the shop and we’ll help you find what’s available.",
  emptyFiltered: "No bikes match these brands right now. Try another brand or call us for help.",

  /** Grid tiles say only this. Bikes Shopify marks in stock render no badge. */
  soldBadge: "Ask about availability",
  soldPrefix: "Availability not confirmed — ",
  soldLink: "ask about this bike",

  /** Product page only. This renders when Shopify reports zero inventory. */
  checkAvailabilityLine: "Current availability is not confirmed online.",
  pastModelLine: "This is a past model. Ask us about current alternatives.",

  askAboutTestRide: "Schedule a test ride",
  askWhatsComing: "Ask about this bike",
  questionsPrefix: "Need help comparing bikes? Call ",

  testRideFacts: "Free · 30 minutes · no purchase required",
  /**
   * Shown when a listing has no Shopify description.
   *
   * Says only what is true of every bike in the building — it must never
   * describe THIS bike, because the whole reason it renders is that nobody told
   * us anything about this bike. Both claims are already made elsewhere on the
   * site: the shop rides what it sells, and a person answers the phone during
   * open hours.
   */
  noDescriptionFallback:
    "Want help deciding whether this bike fits your family? Call the shop for a direct comparison, or schedule a test ride and try the bike under your normal load.",
  savingsCallout: {
    eyebrow: "Rebates & savings",
    heading: "Understand the price before you decide",
    body:
      "See the Colorado credit available at purchase, the separate income-qualified rebate lottery, financing, and trade-in choices. Each has different rules.",
    action: "See rebates & savings",
  },
  relatedHeading: "Also from this brand",
  backToAll: "← All the bikes",
} as const;
